import React from 'react';
// import { Link } from 'react-router-dom';
import './style/team.css';

const part1 = [
    {
        id: 1,
        title: "Akshat Narayan Gupta",
        role: "Full-Stack Developer",
        dept: "Information Technology",
        roll: "10800218085",
        img: "Akshat Narayan Gupta"
    },
    {
        id: 2,
        title: "Ananya Kumar",
        role: "Front-End Developer",
        dept: "Information Technology",
        roll: "10800218076",
        img: "Ananya Kumar"
    },
    {
        id: 3,
        title: "Gaurav Kumar Singh",
        role: "Front-End Developer",
        dept: "Information Technology",
        roll: "10800218068",
        img: "Gaurav Kumar Singh"
    },
    {
        id: 4,
        title: "Arya Tewary",
        role: "Back-End Web Developer",
        dept: "Information Technology",
        roll: "10800218072",
        img: "Arya Tewary"
    }
]

const part3 = [
    {
        id: 1,
        title: "Barsha Bhattacharya",
        role: "Back-End Web Development",
        dept: "Information Technology",
        roll: "10800218070",
        img: "Barsha Bhattacharya"
    },
]

const Team = () => {
      return (
        <div className='team-container' >
            {/* fleet-container*/}
            <div className='holder'>
                {/* container */}
                <div className='team-header'>
                    {/* fleet-header */}
                    <h1 className="heading">Our Team</h1>
                </div>
                <div>
        <div className='image-container'>
            {/* card-container */}
          { part1.map( part1 => (
              <div className='image-image-image-box' id={part1.id} >
                  {/* card-box */}
              <div className='image-image'>
                  {/* card-image */}
                  <img src={require(`../assets/team/${part1.img}.jpeg`)} alt='card-img'></img>
              </div>
              <div className='image-detail'>
                  {/* card-detail */}
                  <h4 className="members">{part1.title}</h4>
                  <p className="info">{part1.role}</p>
                  <p className="info">{part1.dept}</p>
                  <p className="info">{part1.roll}</p>
              </div>
          </div>
          ))}
        </div>;
        {/* <div className='image-container'>
        { part2.map( part2 => (
            <div className='image-box' id={part2.id} >
            <div className='image-image'>
                <img src={require(`../assets/team/${part2.img}.jpeg`)} alt='card-img'></img>
            </div>
            <div className='iamge-detail'>
                <h4>{part2.title}</h4>
                <p>{part2.role}</p>
                  <p>{part2.dept}</p>
                  <p>{part2.roll}</p>
            </div>
        </div>
        ))}
      </div>; */}
      <div className='image-container'>
      { part3.map( part3 => (
          <div className='image-image-image-box' id={part3.id} >
          <div className='image-image'>
              <img src={require(`../assets/team/${part3.img}.jpeg`)} alt='card-img'></img>
          </div>
          <div className='image-detail'>
              <h4 className="members">{part3.title}</h4>
              <p className="info">{part3.role}</p>
                  <p className="info">{part3.dept}</p>
                  <p className="info">{part3.roll}</p>
          </div>
      </div>
      ))}
    </div>;
    </div>
            </div>
        </div>
      );
}
  
export default Team;